import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-pre-enlistment-success',
  templateUrl: './pre-enlistment-success.component.html',
  styleUrls: ['./pre-enlistment-success.component.scss']
})
export class PreEnlistmentSuccessComponent {
  @Output() checkClearance = new EventEmitter<void>();
  @Output() returnToDashboard = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();
}